import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function pickupsRoutes() {
    return {
        index,
        get,
        create,
        update,
        remove,
        addPickups,
        removePickup
    };

    function index(options = {}) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`list-pickup/search${params}`);
    }

    function get(routePickupId) {
        return axiosInstance.get(`list-pickup/get?id=${routePickupId}`);
    }

    function create(data) {
        return axiosInstance.post('list-pickup/create', data);
    }

    function update(data) {
        return axiosInstance.patch('list-pickup/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`list-pickup/delete`, {
            data: {
                id: id
            }
        });
    }

    function addPickups(pickupRoutesId, pickupOrders) {
        return axiosInstance.post('list-pickup/add-pickups', {
            routeId: pickupRoutesId,
            pickupOrders
        });
    }

    function removePickup(payload) {
        return axiosInstance.post('list-pickup/remove-pickups', {
            routeId: payload.pickupRoutesId,
            pickupOrders: payload.pickupOrders
        });
    }
}
